import { FC } from "react";

import type { CompactionEvent } from "@tsmono/inspect-common/types";
import { MetaDataGrid } from "@tsmono/inspect-components/content";
import { formatDateTime } from "@tsmono/util";

import styles from "./CompactionEventView.module.css";
import { EventPanel } from "./event/EventPanel";
import { formatTitle } from "./event/utils";
import { EventNode } from "./types";

interface CompactionEventViewProps {
  eventNode: EventNode<CompactionEvent>;
  className?: string;
}

export const CompactionEventView: FC<CompactionEventViewProps> = ({
  eventNode,
  className,
}) => {
  const event = eventNode.event;
  let data: Record<string, unknown> = {};
  if (event.tokens_before) {
    data["tokens_before"] = event.tokens_before;
  }
  if (event.tokens_after) {
    data["tokens_after"] = event.tokens_after;
  }
  data = { ...data, ...(event.metadata || {}) };

  const source =
    event.source && event.source !== "inspect" ? ": " + event.source : "";

  return (
    <EventPanel
      eventNodeId={eventNode.id}
      title={formatTitle("Compaction" + source, undefined, event.working_start)}
      className={className}
      subTitle={formatDateTime(new Date(event.timestamp))}
      icon="compaction"
    >
      <MetaDataGrid
        entries={data}
        className={styles.panel}
        options={{ copyButton: true }}
      />
    </EventPanel>
  );
};
